export default __webpack_public_path__ + "static/media/TAFC-ongreen_1.7c3c268e.svg";